import { Routes, Route } from "react-router-dom";
import AuthLayout from "./layouts/Auth";
import Home from "./pages/Home";
import ImportArea from "./pages/ImportArea";
import Master from "./pages/Master";
import ControlPanel from "./pages/ControlPanel";
import NotFound from "./components/NotFound";
import Header from "./components/Header";
import Product from "./pages/Product";
import SingleFile from "./pages/SingleFile";
// import Catalogs from "./pages/Catalogs";
// import Catalog from "./pages/Catalog";
import Catalogue from "./pages/Catalogue";
import SingleProduct from "./pages/SingleProduct";
import Protected from "./layouts/Protected";
import Profile from "./pages/Profile";
import EditProduct from "./pages/ControlPanel/editProduct";
import Search from "./pages/Search";
import UserPermission from "./pages/UserPermission";
import UserPermissions from "./pages/UserPermissions";
import UserPermissionNew from "./pages/UserPermissionNew";
import UserPermissionUpdate from "./pages/UserPermissionUpdate";

import Banner from "./pages/Banner";
import Banners from "./pages/Banners";
import BannerNew from "./pages/BannerNew";
import BannerUpdate from "./pages/BannerUpdate";

import "./App.css";

function App() {
  return (
    <AuthLayout>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        {/* <Route path="/catalogs" element={<Catalogs />} />
        <Route path="/catalog" element={<Catalog />} /> */}
        <Route path="/catalogue" element={<Catalogue />} />
        <Route
          path="/userPermissions"
          element={
            <Protected>
              <UserPermissions />
            </Protected>
          }
        />
        <Route path="/userPermission">
          <Route
            path="new"
            element={
              <Protected>
                <UserPermissionNew />
              </Protected>
            }
          />
          <Route
            path=":permissionId"
            element={
              <Protected>
                <UserPermission />
              </Protected>
            }
          >
            <Route
              path="update"
              element={
                <Protected>
                  <UserPermissionUpdate />
                </Protected>
              }
            />
          </Route>
        </Route>
        <Route path="/search" element={<Search />} />
        <Route path="product">
          <Route
            path=":productId"
            element={
              <Protected>
                <Product />
              </Protected>
            }
          >
            <Route
              path="show"
              element={
                <Protected>
                  <SingleProduct />
                </Protected>
              }
            />
            <Route
              path="file/:fileId"
              element={
                <Protected>
                  <SingleFile />
                </Protected>
              }
            />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
        <Route
          path="importArea"
          element={
            <Protected>
              <ImportArea />
            </Protected>
          }
        />
        <Route
          path="master"
          element={
            <Protected>
              <Master />
            </Protected>
          }
        />
        <Route
          path="controlPanel"
          element={
            <Protected>
              <ControlPanel />
            </Protected>
          }
        />
        <Route path="controlPanel">
          <Route
            path="product/:productId/"
            element={
              <Protected>
                <Product />
              </Protected>
            }
          >
            <Route
              path="edit"
              element={
                <Protected>
                  <EditProduct />
                </Protected>
              }
            />
          </Route>
        </Route>
        <Route
          path="/banners"
          element={
            <Protected>
              <Banners />
            </Protected>
          }
        />
        <Route path="/banner">
          <Route
            path="new"
            element={
              <Protected>
                <BannerNew />
              </Protected>
            }
          />
          <Route
            path=":bannerId"
            element={
              <Protected>
                <Banner />
              </Protected>
            }
          >
            <Route
              path="update"
              element={
                <Protected>
                  <BannerUpdate />
                </Protected>
              }
            />
          </Route>
        </Route>
      </Routes>
    </AuthLayout>
  );
}

export default App;
